import React, { useEffect, useState } from 'react';
import { getPrivateMoneys, PrivateMoney } from 'admin/actions/private-moneys';
import Select from 'admin/components/atoms/Select';
import { toQueryParams } from 'admin/utils';

type Props = {
  organizationCode?: string;
  value: string | null;
  onChange: (moneyId: string | null) => void;
  excludeMoneyId?: string;
  disabled?: boolean;
  noneOptionLabel?: string;
  noOrganizationPlaceholder?: string;
};

const OrganizationMoneySelect = ({
  organizationCode,
  value,
  onChange,
  excludeMoneyId,
  disabled = false,
  noneOptionLabel,
  noOrganizationPlaceholder = '組織を先に選択してください',
}: Props) => {
  const [moneys, setMoneys] = useState<PrivateMoney[]>([]);

  useEffect(() => {
    if (!organizationCode) {
      setMoneys([]);
      return undefined;
    }
    let active = true;
    getPrivateMoneys(toQueryParams({ organization_code: organizationCode, per_page: 10000 })).then(
      ({ rows }) => {
        if (!active) return;
        setMoneys(rows);
        if (value && !rows.some((m) => m.id === value)) onChange(null);
      }
    );
    return () => {
      active = false;
    };
  }, [organizationCode]);

  const moneyOptions = moneys
    .filter((m) => m.id !== excludeMoneyId)
    .map((m) => ({ label: m.name, value: m.id }));
  const options = noneOptionLabel
    ? [{ label: noneOptionLabel, value: '' }, ...moneyOptions]
    : moneyOptions;

  return (
    <Select
      fullWidth
      isMulti={false}
      options={options}
      value={options.find((x) => x.value === value) ?? null}
      onChange={(option) => onChange(option?.value || null)}
      isDisabled={disabled || !organizationCode}
      placeholder={organizationCode ? 'Select...' : noOrganizationPlaceholder}
    />
  );
};

export default OrganizationMoneySelect;
